import { styled } from '@vebox/etui-system';
import { createElement, Children, isValidElement, cloneElement } from 'react';
import { Div } from '@vebox/etui-system-elements';
import { isValueSelected } from './utils/index.js';

const ButtonGroupDiv = styled(Div)`
  display: flex;
  background-color: transparent;
`;

const ButtonGroup = props => {
  const {
    children,
    onButtonSelected,
    value,
    exclusive = true,
    deselect
  } = props;
  const makeArrayOfSelectedValues = (firstVal, secondVal) => {
    const index = firstVal && firstVal.indexOf(secondVal);
    let newValue;
    if (firstVal && index >= 0) {
      newValue = [...firstVal];
      return newValue.splice(index, 1);
    }
    return firstVal ? [...firstVal, secondVal] : [secondVal];
  };
  const handleChange = (event, buttonValue) => {
    if (!onButtonSelected) {
      return;
    }
    const newValue = makeArrayOfSelectedValues(value, buttonValue);
    onButtonSelected(event, newValue);
  };
  const handleExclusiveChange = (event, buttonValue) => {
    if (!onButtonSelected) {
      return;
    }
    if (deselect) {
      onButtonSelected(event, value === buttonValue ? null : buttonValue);
    } else {
      onButtonSelected(event, buttonValue);
    }
  };
  return /*#__PURE__*/createElement(ButtonGroupDiv, null, Children.map(children, child => {
    if (! /*#__PURE__*/isValidElement(child)) {
      return null;
    }
    const {
      active,
      value: buttonValue
    } = child.props;
    const selected = active === undefined ? isValueSelected(buttonValue, value) : active;
    return /*#__PURE__*/cloneElement(child, {
      active: selected,
      onButtonSelected: exclusive ? handleExclusiveChange : handleChange
    });
  }));
};

export default ButtonGroup;
